import { render, staticRenderFns } from "./heads.vue?vue&type=template&id=b7e50246&scoped=true"
import script from "./heads.vue?vue&type=script&lang=js"
export * from "./heads.vue?vue&type=script&lang=js"
import style0 from "./heads.vue?vue&type=style&index=0&id=b7e50246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e50246",
  null
  
)

export default component.exports